import type { LatencyPoint } from "./definitions/LatencyPoint";

/** Sum of all proportions in the dataset (not exactly 1 due to source rounding). */
export function totalProbability(data: LatencyPoint[]): number {
  return data.reduce((sum, [, p]) => sum + p, 0);
}

/** Weighted-mean latency: Σ(latency × proportion) / Σ(proportion). */
export function calculateAverage(data: LatencyPoint[]): number {
  const total = totalProbability(data);
  const weightedSum = data.reduce((sum, [t, p]) => sum + t * p, 0);
  return weightedSum / total;
}

/**
 * Normalized percentage of trades executed strictly below `threshold` ms,
 * scaled so the dataset's proportions are treated as summing to 100%.
 */
export function calculatePercentageBelow(
  data: LatencyPoint[],
  threshold: number,
): number {
  const total = totalProbability(data);
  const cumulative = data
    .filter(([t]) => t < threshold)
    .reduce((sum, [, p]) => sum + p, 0);
  return (cumulative / total) * 100;
}
